// 节日福利
export const aiHelperRouter = [
  {
    path: '/AI/UserStatistics',
    name: 'UserStatistics',
    component: () => import('../views/AI/UserStatistics')
  },
   {
    path: '/AI/QuestionAnser',
    name: 'QuestionAnser',
    component: () => import('../views/AI/QuestionAnser')
  } ,
   {
    path: '/AI/Basicinfo',
    name: 'Basicinfo',
    component: () => import('../views/AI/Basicinfo')
  } ,
   {
    path: '/userStatistics/index',
    name: 'userStatistics',
    component: () => import('../views/userStatistics/index.vue')
  } 
];